import ipxStaticRuntime_36e5uCAJkLOjDzY2_fPDo4B__FL4iMp7CbZJMvrGZE64E from '/builds/eotlab/eotlab-website/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["avif","webp"],
  quality: undefined,
  /** @type {"ipxStatic"} */
  provider: "ipxStatic",
  providers: {
      ['ipxStatic']: { setup: ipxStaticRuntime_36e5uCAJkLOjDzY2_fPDo4B__FL4iMp7CbZJMvrGZE64E, defaults: {} }
  }
}
